import { useEffect, useSyncExternalStore } from "react";
import { timing } from "../config";
import { getRuntimeConfig, loadRuntimeConfig, subscribeRuntimeConfig } from "./runtimeConfig";

export const marketsTiming = timing.markets;

export function useMarkets() {
  const config = useSyncExternalStore(subscribeRuntimeConfig, getRuntimeConfig);
  const enabled = config?.markets !== undefined;
  useEffect(() => {
    if (!enabled) return;
    let disposed = false;
    let pending = false;
    const refresh = async () => {
      if (disposed || pending || document.hidden) return;
      pending = true;
      try { await loadRuntimeConfig(true); } finally { pending = false; }
    };
    const timer = window.setInterval(() => void refresh(), marketsTiming.pollMs);
    const visible = () => { if (!document.hidden) void refresh(); };
    window.addEventListener("focus", visible);
    document.addEventListener("visibilitychange", visible);
    return () => {
      disposed = true;
      window.clearInterval(timer);
      window.removeEventListener("focus", visible);
      document.removeEventListener("visibilitychange", visible);
    };
  }, [enabled]);
  return config?.markets;
}
